export default __webpack_public_path__ + "assets/images/77c9a97c28c6f838411e82c8fdb0b9f5.png";